import React, { useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Typography, Grid } from "@material-ui/core"
import Container from "@material-ui/core/Container"
import CardsInvestment from "./CardsInvestment"
import "./Ofrecemos.css"
import bgBlob from "../assets/Investment/investment-background-top.svg"

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 0, 2, 0),
    background: `url(${bgBlob})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
  },
  description: {
    marginBottom: theme.spacing(3),
  },
  cardTitle: {
    fontSize: 16,
  },
  subtitle: {
    fontSize: 15,
    textAlign: "rigth",
    width: 350,
  },
  marginText: {
    marginBottom: theme.spacing(4),
  },
}))

function scrollToElement(id) { // scroll listo, esperando el elemento id
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({ behavior: "smooth" })
  }
}

export default function HowItWorks() {
  useEffect(() => {
    const hash = window.location.hash
    const idInversion = hash.substring(1)

    if (idInversion) {
      scrollToElement(idInversion)
    }
  }, [])


  const classes = useStyles()
  return (
    <div className={classes.root + " backgroundO"} id="Inversion">
      <Container>
        <Grid container justify="center" alignItems="center">
          <Grid className={classes.description} item xs={12}>
            <Typography align="center" variant="overline" component="p">
              Inversión
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}